import React from 'react';
import { Skeleton } from '@material-ui/lab';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


import Breadcrumbs from '../../elements/Breadcrumbs';
import { BodyContainer, MobileCard, MobileCardDate, MobileCardTitle, MobileCardFormat, FiltersContainer, FilterItem } from './Medcard.style';
import moment from 'moment';
import { grey, lightGray, mainGray } from '../../assets/ui/colors';
import useWindowDimensions from '../Lk/useWindowDimensions';
import FiltersIcon from '../../assets/allIcons/FiltersIcon';

const SmallCard = ({ data, getResultPdf }) => {
    return (
        <MobileCard onClick={() => getResultPdf(data.prescId, data.nameDoc)}>
            <MobileCardTitle>{data.nameDoc}</MobileCardTitle>
            {data.researchPlace}
            <MobileCardDate>
                {moment(data.dateSign).format('DD.MM.YYYY, HH:mm')}
            </MobileCardDate>
            {data.recommendations}
            <MobileCardFormat>PDF</MobileCardFormat>
        </MobileCard>
    )
}


const Medcard = ({
    isLoading,
    mdocs,
    selectedFilter,
    onChangeFilter,
    getResultPdf,
}) => {
    const windowWidth = useWindowDimensions().width;

    const StyledTableCell = withStyles((theme) => ({
        head: {
            fontSize: '12px',
            lineHeight: '24px',
            color: mainGray,
            background: lightGray,
            textTransform: 'uppercase',
        },
        body: {
            fontSize: '14px',
            lineHeight: '24px',
            cursor: 'pointer',
        },
    }))(TableCell);

    const filters = [{
        label: 'Весь период',
        dateStart: "",
        dateEnd: "",
    }, {
        label: 'Год',
        dateStart: moment().add(-1, 'year').format('YYYY-MM-DD'),
        dateEnd: moment().add(1, 'days').format('YYYY-MM-DD'),
    }, {
        label: 'Месяц',
        dateStart: moment().add(-1, 'month').format('YYYY-MM-DD'),
        dateEnd: moment().add(1, 'days').format('YYYY-MM-DD'),
    }, {
        label: 'Неделя',
        dateStart: moment().add(-1, 'week').format('YYYY-MM-DD'),
        dateEnd: moment().add(1, 'days').format('YYYY-MM-DD'),
    }]

    return (
        <>
            <Breadcrumbs pathArr={[{ label: 'Медкарта' }]} />
            <FiltersContainer>
                {filters.map((item) =>
                    <FilterItem
                        key={item.label}
                        isActive={selectedFilter === item.label}
                        onClick={() => onChangeFilter(item)}
                    >
                        {item.label}
                    </FilterItem>
                )}
                <FiltersIcon />
            </FiltersContainer>
            {mdocs.length
                ? <BodyContainer>
                    {windowWidth > 780
                        ? isLoading
                            ? <>
                                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                            </>
                            : <Table aria-label="mdocs table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Наименование</StyledTableCell>
                                        <StyledTableCell align="left">Дата получения</StyledTableCell>
                                        <StyledTableCell align="center">Формат</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mdocs.map((row) => (
                                        <TableRow
                                            key={row.prescId}
                                            onClick={() => getResultPdf(row.prescId, row.nameDoc)}
                                            hover
                                        >
                                            <StyledTableCell component="th" scope="row">
                                                {row.nameDoc}
                                            </StyledTableCell>
                                            <StyledTableCell align="left">{moment(row.dateSign).format('DD.MM.YYYY, HH:mm')}</StyledTableCell>
                                            <StyledTableCell align="center">PDF</StyledTableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        : isLoading
                            ? <>
                                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                            </>
                            : <>
                                {mdocs.map((row) => (
                                    <SmallCard data={row} key={row.prescId} getResultPdf={getResultPdf} />
                                ))}
                            </>
                    }
                </BodyContainer>
                : <div>Здесь будет список ваших медицинских результатов</div>
            }
        </>
    )
}

export default Medcard;
